import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetCollection_pointsConsumptionsExportCsv = z.any()
export type TagsGetCollection_pointsConsumptionsExportCsv = z.infer<typeof tagsGetCollection_pointsConsumptionsExportCsv>

export const descriptionGetCollection_pointsConsumptionsExportCsv = z.any()
export type DescriptionGetCollection_pointsConsumptionsExportCsv = z.infer<typeof descriptionGetCollection_pointsConsumptionsExportCsv>

export const querystringGetCollection_pointsConsumptionsExportCsv = z.object({ "collectionPointId": z.string().uuid().optional(), "buildingId": z.string().uuid().optional(), "from": z.string().date().optional(), "to": z.string().date().optional() })
export type QuerystringGetCollection_pointsConsumptionsExportCsv = z.infer<typeof querystringGetCollection_pointsConsumptionsExportCsv>

export const responseGetCollection_pointsConsumptionsExportCsv = z.any()
export type ResponseGetCollection_pointsConsumptionsExportCsv = z.infer<typeof responseGetCollection_pointsConsumptionsExportCsv>

interface IGetCollection_pointsConsumptionsExportCsv extends BaseMethodType {
  tags: TagsGetCollection_pointsConsumptionsExportCsv,
  description: DescriptionGetCollection_pointsConsumptionsExportCsv,
  querystring: QuerystringGetCollection_pointsConsumptionsExportCsv,
  response: ResponseGetCollection_pointsConsumptionsExportCsv
}
export const URL = '/collection-points/consumptions/export/csv'
export const validation = {
  get: {
    tags: tagsGetCollection_pointsConsumptionsExportCsv,
    description: descriptionGetCollection_pointsConsumptionsExportCsv,
    querystring: querystringGetCollection_pointsConsumptionsExportCsv,
    response: responseGetCollection_pointsConsumptionsExportCsv
  }
}
export interface Collection_pointsConsumptionsExportCsv extends BaseRouteType {
  get: IGetCollection_pointsConsumptionsExportCsv
}